import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Modal, ModalBody, ModalFooter, Button, Input } from "reactstrap";
import i18n from "../../../i18n";
import { patchEndServiceWithoutPassenger } from "../../../helpers/api_rombo_helper";

const FinishServiceModal = ({ isOpen, toggle, selectedService }) => {

  const [note, setNote] = useState("");
  const [isNoteValid, setIsNoteValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );

  const { token } = useSelector(LoginProperties);

  const handleFinishService = async () => {
    if (!note.trim()) return;
  
    setIsLoading(true);
  
    const path = selectedService.code;
    const payload = {
      reason: note,
      is_without_passengers: true,
    };
  
    try {
      await patchEndServiceWithoutPassenger(token, path, payload);
      setNote("");
      toggle();
    } catch (error) {
      console.error("Error finishing service:", error);
    } finally {
      setIsLoading(false);
    }
  };  

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={false}
      centered
      className="RequestModal"
      toggle={toggle}
      backdrop="static"
      size="lg"
    >
      <div>
        <div className="modal-header-container">
          <p className="cancellation-title modal-header-bottom">
            {i18n.t("EndServiceWithoutPassenger")}
          </p>
          <p className="cancellation-text modal-service-id">
            {selectedService?.code}
          </p>
        </div>
        <div className="modal-separator" />
        <ModalBody>
          <p className="modal-text-bold">
            {i18n.t("FinishServiceText")}
          </p>
          <Input
            type="textarea"
            className="form-control"
            placeholder={i18n.t("WriteYourNoteHere")}
            value={note}
            maxLength={200}
            onChange={(e) => {
              setNote(e.target.value.slice(0, 200));
              setIsNoteValid(e.target.value.trim() !== "");
            }}
          />
          <small className="text-muted">
            {note.length}/200 {i18n.t("Characters")}
          </small>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-users border"
            type="button"
            onClick={handleFinishService}
            disabled={!isNoteValid || isLoading}
          >
            {isLoading ? i18n.t("Finishing...") : i18n.t("Finish")}
          </Button>
          <Button className="btn btn-light" type="button" onClick={toggle}>
            {i18n.t("Cancel")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

FinishServiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  selectedService: PropTypes.object.isRequired,
};

export default FinishServiceModal;
